
<template>
    <div id="digital-payment">
      <NavBar :mainPage="mainPage" />
      <section id="digitalPayment-intro-section" class="digitalPayment-intro-section" ref="digitalpaymentstart">
        <DigitalPaymentsIntro
          class="privacy-in"
          :heading="headings.first"
          :paragraph="paragraph.first"
        />
      </section>
      
      <!-- Main Content Section -->
      <section class="container mx-auto p-6">
        <h2 class="text-2xl font-semibold mt-6 text-left">Who Can Use ftcash?</h2>
        <p>Our payment solutions are designed for a wide range of businesses, including:</p>
        <ul class="list-disc pl-6 mt-2">
          <li>🛒 Grocery Stores – Accept digital payments without cash handling.</li>
          <li>🏪 Departmental Stores – Speed up checkout with seamless card, UPI, and net banking payments.</li>
          <li>🥦 Vegetable & Fruit Vendors – Collect instant payments via QR code and UPI.</li>
          <li>👕 Clothing & Apparel Stores – Offer multiple payment options for a smooth shopping experience.</li>
          <li>🛍 Retail Shops – Accept all digital payment modes.</li>
          <li>☕ Cafés & Restaurants – Simplify billing with fast and secure payment collection.</li>
          <li>🏥 Pharmacies & Medical Stores – Provide a cashless payment option.</li>
          <li>🚖 Service Providers – Accept payments for car service centers and professional services.</li>
        </ul>
        
        <h2 class="text-2xl font-semibold mt-6 text-left">Comprehensive Payment Acceptance</h2>
        <ul class="list-disc pl-6 mt-2">
          <li>Unique Payment URL – Generate and share secure payment links.</li>
          <li>POS System – Accept card payments through secure POS devices.</li>
          <li>QR Code Payments – Enable instant transactions via UPI.</li>
        </ul>
        
        <h2 class="text-2xl font-semibold mt-6 text-left">Multiple Payment Methods</h2>
        <ul class="list-disc pl-6 mt-2">
          <li>Credit & Debit Cards – Accept payments from all major card networks.</li>
          <li>Net Banking – Allow direct payments from bank accounts.</li>
          <li>UPI & QR Code – Offer instant transactions for faster checkouts.</li>
        </ul>
        
        <h2 class="text-2xl font-semibold mt-6 text-left">Why Choose ftcash?</h2>
        <ul class="list-disc pl-6 mt-2">
          <li> Secure & Reliable Transactions – PCI-compliant with fraud protection.</li>
          <li> Fast & Easy Settlements – Quick fund transfers to merchants.</li>
          <li> User-Friendly Interface – Dashboard to track and manage transactions.</li>
          <li> No Hardware Dependency – Accept payments digitally without extra infrastructure.</li>
        </ul>

        <p>With ftcash, businesses can enhance customer experience, reduce cash handling, and streamline operations effortlessly.</p>
      
        <p>Start accepting digital payments today with ftcash!</p>
      </section>
  
      <!-- Footer Section -->
      <section id="contact-footer" class="fullpage" v-lazy:background-image="require(`@/assets/background/footer_bg.png`)">
        <Footer id="foot" />
      </section>
    </div>
  </template>
  
  <script>
import DigitalPaymentsIntro from "./digital-payments-intro";
  
  export default {
    name: "digitalPaymentintro",
    // props: ["heading", "paragraph"],
    components: {
      DigitalPaymentsIntro,
        // Policies,
    },
    data() {
      return {
        mainPage: false,
        headings: {
            first: "ftcash: Seamless Digital Payment Solutions for Every Retail Business",
        },
        paragraph: {
            first:
            "At ftcash, we empower retailers with a secure and hassle-free digital payment solution, enabling them to accept payments effortlessly.",
        },
      };
    },
    mounted() {
        
        this.$refs.digitalpaymentstart.scrollIntoView({behavior: "smooth", block: "start", inline: "start"});
        //window.scrollTo(0, 0);
    },
    metaInfo() {
      return{
      link: [
        { rel: 'canonical', href: 'https://www.ftcash.com/ftcash-digital-payments' },
      ],
      }
    },
  };
  </script>
  
  <style scoped>
  body {         
    height: auto;
    line-height: 1.6;
    overflow: scroll;
    text-align: left; /* Aligns all text to the left by default */
  }
  
  #digital-payment {
    overflow-y: hidden;
  }
  
  .digitalPayment-intro-section {
    height: 100vh;
    background-image: url("../assets/img/privacy_policy_intro.jpg");
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    background-attachment: fixed;
    -o-background-size: cover;
    -moz-background-size: cover;
    -webkit-background-size: cover;
  }
  
  .container {
    text-align: left; /* Ensures all the text inside the container is left-aligned */
  }
  
  h1, h2, p, li {
    text-align: left; /* Makes sure the headings, paragraphs, and list items align to the left */
  }
  
  /* Media Queries */
  /* Tablet Screen */
  @media (min-width: 768px) and (max-width: 1024px) and (orientation: portrait) {
    section#digitalPayment-intro-section {
      height: 55vh;
      display: flex !important;
      flex-direction: column;
      align-items: flex-start; /* Aligns items to the start (left) */
      justify-content: center;
      scroll-snap-align: center;
    }
  }
  
  /* Mobile Screen */
  @media (min-width: 481px) and (max-width: 767px) {
    section#digitalPayment-intro-section {
      height: 50vh;
      display: flex !important;
      align-items: flex-start; /* Aligns items to the start (left) */
      scroll-snap-align: center;
    }
  }
  
  @media (max-width: 480px) {
    section#digitalPayment-intro-section {
      height: 59vh;
      display: flex !important;
      align-items: flex-start; /* Aligns items to the start (left) */
      scroll-snap-align: center;
    }
  }
  
  </style>
  